module.exports = __webpack_public_path__ + "media/application/images/icons/link-white-f21bc97d3c3e4011a13ae97e503b6f1f.svg";